import React from "react"
import StyledImage from "./styled-image"
import RollingHills from "./icons/rolling-hills"
import BannerVideo from "./banner-video"
import Cta from "./cta"
import HoursTable from "./hours-table"
import { kebabCase } from "lodash"
import { Block } from "./content-section"
import Breadcrumb from "./breadcrumb"

export default function Banner({ props, children, noFlip = false, index }) {
  const { heading, subheading, breadcrumb, content, cta, secondaryCta, ctas, background, hideOnMobile, image, video, videoEmbed, videoTitle, videoOptions, hours, icon, blocks, imageOptions, imageBorderColor, links, ctaFormat } = props
  const overlay = background === 'dark' || background === "none"
  const colorBackground = background === "green" || background === "gold" || background === "lightGray" || background === "red" || background === "ruby"
  const whiteText = background === "red" || background === "green" || background === "ruby"
  const flipped = !noFlip && ((image === null && video === null && blocks ? true : false) || (colorBackground ? true : false))
  const hasContent = heading || subheading || content || links || hours || cta || secondaryCta || ctas
  return (
    <section
      className={`${hideOnMobile ? "hidden md:flex" : "flex"} ${overlay ? "md:bg-banner-gradient md:min-h-1/2-screen md:flex-row" : `lg:min-h-1/3-screen lg:flex-row ${colorBackground || background === "rollingHills" ? "pb-2 lg:py-9 " : "mb-2 lg:my-9 "}`} ${whiteText ? "text-white links-light" : ""} ${background === "green" ? "bg-green" : background === "gold" ? "bg-gold" : background === "red" ? "bg-[#d0070d]" : background === "lightGray" ? "bg-banner-gradient/10" : background === "ruby" ? "bg-ruby" : ""} relative flex-col items-center`}
      id={heading ? kebabCase(heading) : subheading ? kebabCase(subheading) : index ? `section-${index}` : null}
    >
      {background === "dark" || background === "rollingHills" || background === "ruby" ? <RollingHills className={`${background === "rollingHills" ? "bg-rolling-hills-green" : ""}`} /> : null}

      {(image || video || videoEmbed) ? <div className={`h-72 sm:h-96 w-full relative hero-img ${overlay ? "md:absolute md:inset-0 md:h-auto" : "lg:hidden md:h-[30rem]"}`}>
        <ImageVideo image={image} video={video} videoEmbed={videoEmbed} videoTitle={videoTitle} videoOptions={videoOptions} options={imageOptions} className="w-full h-full min-h-[11rem]" />
      </div> : null}

      <div className={`container`}>

        <div className={`relative flex items-center justify-center h-full ${overlay ? "md:justify-normal" : `${flipped ? "flex-wrap lg:flex-nowrap flex-row-reverse xl:gap-x-12 2xl:gap-x-20" : ""} ${colorBackground || background === "shadow" ? "gap-8" : `flex-row lg:items-start ${background === "rollingHills" ? "" : index === 0 ? "lg:pb-11 lg:border-b border-b-slate/25" : ""}`}`}`}>
          {(image || video || videoEmbed) ?
            <div
              className={`hidden hero-img ${overlay ? "" : `lg:block relative ${flipped || background === "shadow" ? "w-1/2 xl:w-3/5" : "mr-6 w-2/3"} lg:min-h-[21rem] xl:min-h-[26.25rem] 2xl:min-h-[32rem]`}`}>
              {/* <motion.div 
              // style={{ y }}*/}
              <ImageVideo image={image} video={video} videoEmbed={videoEmbed} videoTitle={videoTitle} videoOptions={videoOptions} options={{ ...imageOptions, imageBorderColor }} className={`w-full h-full min-h-[10rem] aspect-video ${flipped || background === "shadow" ? "static" : background === "rollingHills" ? "shadow-spread-xs" : ""}`} />
              {/* </motion.div> */}
            </div>
            : (flipped && blocks?.length) ?
              <div className={`grid order-last lg:order-first w-full ${blocks.length > 1 ? "sm:grid-cols-2 lg:w-1/2 xl:w-3/5" : "justify-center lg:w-1/3"} gap-4 md:gap-8 lg:gap-4 xl:gap-8 2xl:gap-16 pb-12 lg:pb-0`}>
                {blocks.map((block, index) => {
                  return <Block props={block} key={index} />
                })}
              </div>
              : null}
          {hasContent ?
            <div className={`py-6 ${overlay ? `${background === "dark" ? "md:bg-purple-900/85 md:px-8 md:max-w-md md:my-4" : "md:max-w-sm"}` : `${flipped || background === "shadow" || background === "rollingHills" ? ((!blocks || blocks?.length <= 1) && !image && !video) ? "lg:w-2/3" : "lg:w-1/2 xl:w-2/5" : "lg:w-1/3 lg:pt-0"} ${background === "shadow" ? "p-5 shadow-spread-sm mt-6 lg:mt-0" : ""}`}`}>
              {icon ? (
                <div
                  className={`h-32 w-32 mb-2`}
                >
                  <StyledImage
                    image={icon}
                    objectFit="contain"
                    className={`w-full h-full`} />
                </div>
              ) : null}
              {breadcrumb || heading || subheading ? <div className="mb-2 lg:mb-3">
                {breadcrumb && (
                  <Breadcrumb breadcrumb={breadcrumb} background={background} />
                )}
                {heading ? (
                  <>
                    {index === 0 ? <h1 id={kebabCase(heading)} itemProp="name" className={`mb-1 ${overlay ? "md:text-white" : ""} ${!overlay && heading.length < 36 ? "h1-lg" : ""}`} dangerouslySetInnerHTML={{
                      __html: heading,
                    }} />
                      : <h2 id={kebabCase(heading)} className={`mb-1 leading-normal ${overlay ? "md:text-white" : ""}`} dangerouslySetInnerHTML={{
                        __html: heading,
                      }} />}
                  </>
                ) : null}
                {subheading ? (
                  <>
                    {!heading ? <h3 className={`mb-1 leading-normal ${overlay ? "md:text-white" : ""}`} dangerouslySetInnerHTML={{
                      __html: subheading,
                    }} />
                      : index === 0 ? <h2 className={`h4 mb-1 ${overlay ? "md:text-white" : ""}`} dangerouslySetInnerHTML={{
                        __html: subheading,
                      }} />
                        : <h3 className={`h4 mb-1 leading-normal ${overlay ? "md:text-white" : ""}`} dangerouslySetInnerHTML={{
                          __html: subheading,
                        }} />}
                  </>
                ) : null}
              </div> : null}
              {content && (
                <div
                  className={`parsed-content ${overlay ? "md:text-white md:links-light" : ""} mb-2 lg:mb-3`}
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
              )}
              {children && (
                <div
                  className={`parsed-content ${overlay ? "md:text-white md:links-light" : ""} mb-2 lg:mb-3`}
                >{children}</div>
              )}
              {links && (
                <ul className={`mb-2 lg:mb-3`}>
                  {links.map(({ link }, index) => (
                    <>
                      {link.url && link.title ? <li>
                        <Cta
                          arrow={true}
                          props={link}
                          key={index}
                        />
                      </li> : null}
                    </>
                  ))}
                </ul>
              )}
              {hours ?
                <div className="mb-2">
                  <HoursTable props={hours[0]} includeHeading={hours.length > 1} />
                </div>
                : null
              }
              {cta && (
                <Cta props={cta} className={`btn ${whiteText ? "btn-white-outline" : ctaFormat === "ruby" ? "btn-ruby" : "btn-primary"} mb-2 lg:mb-3 mr-2`} />
              )}
              {secondaryCta && (
                <Cta props={secondaryCta} className={`btn ${whiteText ? "btn-white-outline" : "btn-primary"} mb-2 lg:mb-3 mr-2`} />
              )}
              {ctas && (
                <>
                  {ctas.map((cta, index) => (
                    <Cta props={cta} className={`btn ${whiteText ? "btn-white-outline" : "btn-primary"} mb-2 lg:mb-3 mr-2`} key={index} />
                  ))}
                </>
              )}
            </div> : null}
        </div>
      </div>
    </section>
  )
}
function ImageVideo({ image, video, videoEmbed, videoTitle, videoOptions, className, options }) {
  const imageFocus = options?.imageFocus
  const borderColor = options?.imageBorderColor
  const poster = image?.localFile?.publicURL
  return <>
    <style>
      {borderColor ? `
      .hero-img img {
        border: 10px solid ${borderColor};
      `: ""}
    </style>
    {image ? (
      <StyledImage
        image={image}
        objectFit="cover"
        objectPosition={imageFocus || "center"}
        className={className} />
    ) :
      null}
    {video || videoEmbed ? <BannerVideo video={video} poster={poster} videoEmbed={videoEmbed} videoTitle={videoTitle} videoOptions={videoOptions} /> : null}
  </>
}

